module.exports = __webpack_public_path__ + "img/micro01_off.1b0cda67.png";